import { useEffect } from 'react'

import { useLocation } from 'react-router-dom'

import URLBuilder from '../../lib/URLBuilder'


/**
 * Sends somebody to sign in, and back to where they were going once they have.
 *
 * Not `<Navigate>`: sign-in lives in the dashboard, and each Termly app is a
 * separate bundle, so a Builder router would look for it among its own routes
 * and fall through to the catch-all. A full page load works from either app.
 */
export default function SignInRedirect() {
  const { pathname, search } = useLocation()

  useEffect(() => {
    const signInURL = URLBuilder.loginURL(null, {
      redirect: `${ pathname }${ search }`,
    })

    window.location.replace(signInURL)
  }, [pathname, search])

  return null
}
